module.exports = __webpack_public_path__ + "img/mid-active1.1ca771ea.jpg";